import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import {
  ADD_LANDING_PAGE_ASYNC,
  EDIT_LANDING_PAGE_ASYNC,
  GET_LANDING_PAGE_ASYNC,
} from './constants'

const getLandingPageBody = (state, action) => ({
  landing_page_content: {
    content: state.awarenessCenter.landingPageForm.landingPage.content,
    page_title: state.awarenessCenter.landingPageForm.landingPage.title,
    locale: state.awarenessCenter.landingPageForm.landingPage.locale,
  },
  name: state.awarenessCenter.landingPageForm.landingPage.name,
  training_type: state.awarenessCenter.landingPageForm.landingPage.trainingType,
  force_save: action.payload?.forceSave || false,
})

const editLandingPageEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(EDIT_LANDING_PAGE_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .editLandingPage(
        action.payload.id,
        getLandingPageBody(store.getState(), action),
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) =>
        EDIT_LANDING_PAGE_ASYNC.onSuccess({
          data: response,
        })
      )
      .catch((error) =>
        Observable.of(epicsErrorHandler(EDIT_LANDING_PAGE_ASYNC.onError, error, [400]))
      )
      .takeUntil(action$.ofType(EDIT_LANDING_PAGE_ASYNC.CANCEL))
  )

const addLandingPageEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(ADD_LANDING_PAGE_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .addLandingPage(
        getLandingPageBody(store.getState(), action),
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map(() => ADD_LANDING_PAGE_ASYNC.onSuccess())
      .catch((error) =>
        Observable.of(epicsErrorHandler(ADD_LANDING_PAGE_ASYNC.onError, error, [400]))
      )
      .takeUntil(action$.ofType(ADD_LANDING_PAGE_ASYNC.CANCEL))
  )

const getLandingPageEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(GET_LANDING_PAGE_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .getLandingPage(
        action.payload.id,
        store.getState().partnerOptions.selectedCompany?.value,
        !!store.getState().app.data.partner
      )
      .map((response) =>
        GET_LANDING_PAGE_ASYNC.onSuccess({
          landingPage: response,
        })
      )
      .catch((error) => Observable.of(epicsErrorHandler(GET_LANDING_PAGE_ASYNC.onError, error)))
      .takeUntil(action$.ofType(GET_LANDING_PAGE_ASYNC.CANCEL))
  )

export default combineEpics(getLandingPageEpic, addLandingPageEpic, editLandingPageEpic)
